import * as yup from "yup";

import { ICreateTopUp } from "../../../interfaces-and-types";

export const createTopUpSchema: yup.SchemaOf<ICreateTopUp> = yup
  .object({
    amount: yup
      .number()
      .typeError("Amount is required")
      .required("Amount is required")
      .positive("Amount must be greater than 0"),
    currency: yup.string().required("Currency is required"),
    enable_instant_settlement_providers_only: yup
      .boolean()
      .nullable()
      .optional(),
    wallet_account_tags: yup
      .array()
      .of(
        yup.object().shape({
          account_tag: yup.string().required("Account tag is required"),
          amount: yup
            .number()
            .required("Amount to tag to wallet is required")
            .positive("Amount must be greater than zero")
            .min(0),
          description: yup.string().nullable().optional().max(300),
          metadata: yup
            .mixed()
            .nullable()
            .test("metadata-test", "Invalid metadata", (value) => {
              if (value === null) {
                return true;
              }
              if (typeof value !== "object") {
                return false;
              }
              // test if every key in metadata has a string or object value
              return Object.values(value).every(
                (v) =>
                  typeof v === "string" ||
                  typeof v === "number" ||
                  typeof v === "object"
              );
            }),
        })
      )
      .nullable()
      .optional(),
  })
  .required();
